import { TableSection, TopSection } from '@/features/historic';

export function HistoricPages() {
  return <TableSection />;
}
